import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebTrackService {

  private apiBaseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getList(postData):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl + '/admin/web_track/getList',postData)
  }

  getUSerList(postData):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl + '/admin/web_track/getUSerList',postData)
  }

  getCompanyNameList(postData):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl + '/admin/confirm_stone/getCompanyNameList',postData)
  }

  getDeviceTypeList(postData):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl + '/admin/web_track/getDeviceTypeList',postData)
  }

  getTrackTypes(postData):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl + '/admin/web_track/getTrackTypes',postData)
  }

  TrackDisplayDet(postData):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl + '/admin/web_track/TrackDisplayDet',postData)
  }

}
